const floatingAgentButtonStyles = {
  icon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "accent.main",
  },
  iconSmall: {
    width: "1rem",
    height: "1rem",
  },
  iconLarge: {
    width: "2rem",
    height: "2rem",
  },
};

export default floatingAgentButtonStyles;
